module.exports = __webpack_public_path__ + "img/affordacare-super-preferred-medical.f1e89585.png";